/* eslint-disable react/prop-types */
import React from "react";

import { IColImage } from "../../../interfaces";
import { applyTransformations } from "../../../utils";
import MediaImg from "../../media-img";
import CmsMarkdown from "../../basic/cms-markdown";
import CmsLink from "../../links/cms-link";
import { COMPONENTS } from "../../../constants";

const ColImage = (props) => {
  const { align_text, content, id, image, button }: IColImage = props;
  if (image !== null) {
    image.url = applyTransformations(image.data?.attributes?.url, { w: 600 });
  }
  return (
    <div className="height-full cms-col-image">
      {image.data && (
        <div className="col-image">
          <MediaImg media={image} />
        </div>
      )}
      <div className="d-flex col-content">
        <CmsMarkdown
          content={{
            name: "col-image-name",
            __typename: COMPONENTS.MARKDOWN,
            text: content,
            id,
            align_text
          }}
        />
        <CmsLink link={button} classnames={["btn", "text-center", "mx-auto", "f3", "p-3"]} />
      </div>
    </div>
  );
};

export default ColImage;
